export const calculateItemValues = (item) => {
    const quantity = parseFloat(item.quantity) || 0;
    const unitPrice = parseFloat(item.unit_price) || 0;
    
    // Calculate line amount
    const lineAmount = quantity * unitPrice;
    
    return {
        line_amount: lineAmount.toFixed(3),
    };
};

export const calculateGrossTotal = (items) => {
    return items.reduce((total, item) => {
        return total + (parseFloat(item.line_amount) || 0);
    }, 0);
};